module.exports = __webpack_public_path__ + "css/Ascot.5fd67ca6.css";